// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-HizSVR{background-color:var(--light-color-grey-grey-0,#f7f7fa);flex-direction:column;height:100%;display:flex;position:relative;overflow:hidden}.sheet-header-eMPSsT{border-bottom:1px solid rgba(var(--coze-stroke-5),var(--coze-stroke-5-alpha));align-items:center;height:64px;padding:16px;display:flex}.sheet-header-title-lUbssD{flex-shrink:0;margin-right:24px;font-size:20px;font-weight:500;line-height:24px}.sheet-header-scope-Y4sexK{flex:1;justify-content:flex-end;align-items:center;width:0;height:64px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card-HizSVR`,
	"sheet-header": `sheet-header-eMPSsT`,
	"sheetHeader": `sheet-header-eMPSsT`,
	"sheet-header-title": `sheet-header-title-lUbssD`,
	"sheetHeaderTitle": `sheet-header-title-lUbssD`,
	"sheet-header-scope": `sheet-header-scope-Y4sexK`,
	"sheetHeaderScope": `sheet-header-scope-Y4sexK`
};
export default ___CSS_LOADER_EXPORT___;
